// LLM models offered in the Video Creative analysis + extraction
// pickers. Mirrors the backend registry in sbly-dash-collector
// (src/llm/models.js) — keep the two in sync. Anthropic models run on the
// native SDK and see keyframe images in extraction; the OpenRouter video
// models (Qwen/Gemini) get the whole archived video.

export interface ModelOption {
  value: string;
  label: string;
}

// The PICKER list — deliberately a subset of the backend registry
// (sbly-dash-collector src/llm/models.js), which keeps retired-from-the-picker
// ids callable for stored rows (e.g. storyboards generated on Opus 4.8, or a
// fallback swap to Gemini Flash). Seed any select from stored data through
// coerceModelOption below so a legacy value doesn't blank the control.
export const MODEL_OPTIONS: ModelOption[] = [
  { value: 'claude-opus-5', label: 'Opus 5 (best)' },
  { value: 'claude-sonnet-4-6', label: 'Sonnet (quality)' },
  { value: 'claude-haiku-4-5-20251001', label: 'Haiku (fast/cheap)' },
  { value: 'qwen/qwen3.6-plus', label: 'Qwen3.6 Plus (OpenRouter, video)' },
  { value: 'google/gemini-3.1-pro-preview', label: 'Gemini 3.1 Pro (OpenRouter, video)' },
];

// Map a stored model id onto a pickable option, falling back to the current
// default when the id was retired from the picker.
export function coerceModelOption(model: string | null | undefined): string {
  return model && MODEL_OPTIONS.some(m => m.value === model) ? model : DEFAULT_GENERATION_MODEL;
}

// Analysis is text (Opus default); the video-ingestion stages (extraction and
// shot analysis, which watch the whole video) default to Gemini 3.1 Pro.
// Mirrors the backend stage defaults.
// (google/gemini-pro-latest is an OpenRouter router alias, not a callable id.)
export const DEFAULT_ANALYSIS_MODEL = 'claude-opus-5';
export const DEFAULT_EXTRACTION_MODEL = 'google/gemini-3.1-pro-preview';
// Script/storyboard generation is text-only; Opus is the quality default.
export const DEFAULT_GENERATION_MODEL = 'claude-opus-5';
